import type * as React from "react";
import { Timeout as ViewsSharedTimeout } from "@/auto-converted/views/shared/Timeout.tsx";
import {
  useIsLoggedIn,
  usePostponeLogout,
  useWillBeLoggedOut,
} from "@/stores/LoggedInStatus.ts";

const TimeoutWatcherComponent: React.FC = () => {
  const willBeLoggedOut = useWillBeLoggedOut();
  const postponeLogout = usePostponeLogout();

  if (!willBeLoggedOut) {
    return null;
  }

  return (
    <div id="timeout_modals">
      <ViewsSharedTimeout continue_callback={postponeLogout.mutate} />
    </div>
  );
};

export const TimeoutWatcher: React.FC = () => {
  const isLoggedIn = useIsLoggedIn();

  if (!isLoggedIn) {
    return null;
  }

  return <TimeoutWatcherComponent />;
};
